{
    "no_product_found": "No product selected",
    "add_product": "Add",
    "toast__product_added_title": "Item added",
    "toast__product_added_body": "{{quantity}} {{unit}} added to the draft",
    "iframe_title": "Product Catalog"
}
